import * as faker from 'faker';
import { optional } from '@library/common/functions';

import {
   MockHawb,
   MockBillingParty,
   MockReference,
   MockTradeshow,
   MockCOD,
   MockPOD,
   MockRisks,
} from '@library/common/models/mock';

import {
   Invoice,
   InvoiceTypes,
   InvoiceHawb,
   InvoiceHeader,
   Charge,
   InvoiceCalculator,
} from './invoice';

export class MockInvoice {
   id = faker.datatype.number();

   type = faker.random.arrayElement( Object.keys( InvoiceTypes ));

   account = faker.datatype.number();
   terms = 'Net 30';

   invoicedate = faker.date.past();
   duedate = faker.date.past();

   total = faker.finance.amount();
   // currency: faker.finance.currencyCode(),
   // currency: faker.random.arrayElement([ 'USD', 'CAD', 'JPY', 'EUR', 'GBP' ]),
   currency = 'USD';

   station = new MockBillingParty();

   notes = optional() ? faker.lorem.sentence() : '';

   hawb = MockHawb();
   servicelevel = faker.commerce.productName();

   pickupdate = faker.date.past();

   totalpieces = faker.datatype.number();
   actualweightlbs = faker.datatype.number();
   actualweightkgs = faker.datatype.number();
   volumeweightlbs = faker.datatype.number();
   volumeweightkgs = faker.datatype.number();
   chargeableweightlbs = faker.datatype.number();
   chargeableweightkgs = faker.datatype.number();

   bill_to = new MockBillingParty();
   shipper = new MockBillingParty();
   consignee = new MockBillingParty();

   origin = optional() ? faker.address.state().toUpperCase().slice(0, 3) : undefined;
   destination = optional() ? faker.address.state().toUpperCase().slice(0, 3) : undefined;

   calculator = optional() ? Array.from({ length: faker.datatype.number( 5 ) + 1 }, _ => new MockInvoiceCalculator() ) : undefined;
   charges = Array.from({ length: faker.datatype.number( 20 ) + 1 }, _ => new MockCharge() );

   references = optional() ? Array.from({ length: faker.datatype.number( 10 ) + 1 }, _ => new MockReference() ) : undefined;
   tradeshow = optional() ? [ new MockTradeshow( 'from' ), new MockTradeshow( 'to' ) ] : undefined;

   cod = optional() ? new MockCOD() : undefined;
   pod = optional() ? new MockPOD() : undefined;
   risks = optional() ? new MockRisks() : undefined;

   description = optional() ? faker.lorem.paragraph() : undefined;

   shipmentAccess = optional() ? true : false;
}

export class MockActualInvoice extends Invoice {
   constructor() {
      super({
         id: faker.datatype.number(),
         type: faker.random.arrayElement( Object.keys( InvoiceTypes )),
         account: faker.datatype.number(),
         terms: 'Net 30',
         invoicedate: faker.date.past(),
         duedate: faker.date.past(),
         total: faker.finance.amount(),
         // currency: faker.finance.currencyCode(),
         // currency: faker.random.arrayElement([ 'USD', 'CAD', 'JPY', 'EUR', 'GBP' ]),
         currency: 'USD',
         station: new MockBillingParty(),
         notes: faker.lorem.sentence(),
         attached: Array.from({ length: faker.datatype.number( 10 ) + 1 }, _ => new MockInvoiceHawb() ),
      });
   }
}

export class MockInvoiceHawb extends InvoiceHawb {
   constructor() {
      super();

      this.hawb = MockHawb();
      this.servicelevel = faker.commerce.productName();

      this.total = faker.finance.amount();
      // this.currency = faker.finance.currencyCode();
      // this.currency = faker.random.arrayElement([ 'USD', 'CAD', 'JPY', 'EUR', 'GBP' ]);
      this.currency = 'USD';

      this.invoicedate = faker.date.past();
      this.pickupdate = faker.date.past();

      this.totalpieces = faker.datatype.number();
      this.actualweightlbs = faker.datatype.number();
      this.actualweightkgs = faker.datatype.number();
      this.volumeweightlbs = faker.datatype.number();
      this.volumeweightkgs = faker.datatype.number();
      this.chargeableweightlbs = faker.datatype.number();
      this.chargeableweightkgs = faker.datatype.number();

      this.bill_to = new MockBillingParty();
      this.shipper = new MockBillingParty();
      this.consignee = new MockBillingParty();

      this.origin = faker.address.state().toUpperCase().slice(0, 3);
      this.destination = faker.address.state().toUpperCase().slice(0, 3);

      this.calculator = Array.from({ length: faker.datatype.number( 5 ) + 1 }, _ => new MockInvoiceCalculator() );
      this.charges = Array.from({ length: faker.datatype.number( 20 ) + 1 }, _ => new MockCharge() );

      this.references = Array.from({ length: faker.datatype.number( 10 ) + 1 }, _ => new MockReference() );
      this.tradeshow = [ new MockTradeshow( 'from' ), new MockTradeshow( 'to' ) ];

      this.cod = new MockCOD();
      this.pod = new MockPOD();
      this.risks = new MockRisks();

      this.description = faker.lorem.paragraph();
      this.notes = faker.lorem.sentence();

      this.shipmentAccess = false;
   }
}

export class MockInvoiceHeader extends InvoiceHeader {
   constructor() {
      const type = faker.random.arrayElement( Object.keys( InvoiceTypes ));

      super({
         id: faker.datatype.number(),
         consignee: new MockBillingParty(),
         invoicedate: faker.date.recent( 90 ),
         type,
         total: ( type === 'credit' ? -1 : 1 ) * ( +faker.finance.amount()) * (( Math.random() > 0.9 ) ? 100 : 1 ),
         // currency: faker.finance.currencyCode(),
         currency: faker.random.arrayElement([ 'USD', 'CAD', 'EUR' ]),
         // currency: 'USD',
      });
   }
}

export class MockCharge extends Charge {
   constructor() {
      super({
         description: faker.lorem.words(),
         quantity: faker.datatype.number(),
         rate: faker.datatype.number(),
         amount: faker.finance.amount(),
         // currency: faker.random.arrayElement([ 'USD', 'CAD', 'JPY', 'EUR', 'GRP' ]),
         currency: 'USD',
      });
   }
}

export class MockInvoiceCalculator extends InvoiceCalculator {
   constructor() {
      super({
         item:  faker.datatype.number( 20 ),
         itemType:  faker.random.arrayElement([ 'CARG' ]),

         pieces:  faker.datatype.number( 100 ),
         piecesType:  faker.random.arrayElement([ 'PC', 'PAL', 'CRT' ]),

         length:  faker.datatype.number( 50 ),
         width:  faker.datatype.number( 50 ),
         height:  faker.datatype.number( 50 ),
         dimsType:  faker.random.arrayElement([ 'ft', 'in' ]),

         weight:  faker.datatype.number( 200 ),
         weightType:  faker.random.arrayElement([ 'lbs', 'kgs' ]),

         cubicFt:  faker.datatype.number( 200 ),
         cubicM:  faker.datatype.number( 200 ),

         marks:  faker.lorem.words(),
      });
   }
}
